import React from "react";

import { PAYMENTS_CONFIG } from "./config";

export const columns = [
  {
    Header: () => <span>{PAYMENTS_CONFIG.date.label}</span>,
    accessor: PAYMENTS_CONFIG.date.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[PAYMENTS_CONFIG.date.key]
        ? row[PAYMENTS_CONFIG.date.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{PAYMENTS_CONFIG.balance.label}</span>,
    accessor: PAYMENTS_CONFIG.balance.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[PAYMENTS_CONFIG.balance.key]
        ? String(row[PAYMENTS_CONFIG.balance.key])
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{PAYMENTS_CONFIG.debit.label}</span>,
    accessor: PAYMENTS_CONFIG.debit.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[PAYMENTS_CONFIG.debit.key]
        ? String(row[PAYMENTS_CONFIG.debit.key])
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{PAYMENTS_CONFIG.payment.label}</span>,
    accessor: PAYMENTS_CONFIG.payment.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[PAYMENTS_CONFIG.payment.key]
        ? String(row[PAYMENTS_CONFIG.payment.key])
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{PAYMENTS_CONFIG.total.label}</span>,
    accessor: PAYMENTS_CONFIG.total.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[PAYMENTS_CONFIG.total.key]
        ? String(row[PAYMENTS_CONFIG.total.key])
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{PAYMENTS_CONFIG.source.label}</span>,
    accessor: PAYMENTS_CONFIG.source.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[PAYMENTS_CONFIG.source.key]
        ? row[PAYMENTS_CONFIG.source.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{PAYMENTS_CONFIG.reference.label}</span>,
    accessor: PAYMENTS_CONFIG.reference.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[PAYMENTS_CONFIG.reference.key]
        ? row[PAYMENTS_CONFIG.reference.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{PAYMENTS_CONFIG.status.label}</span>,
    accessor: PAYMENTS_CONFIG.status.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[PAYMENTS_CONFIG.status.key]
        ? row[PAYMENTS_CONFIG.status.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  }
];
